@if (gridOptions) {
  <dv-grid [actions]="actions()">
    <ag-grid-angular
      dvGridInSidesheet
      dvPinSelectedRow
      vtGridRowEditing
      [entity]="entity.VehicleDocument"
      [entityId]="$safeNavigationMigration(selectedNode?.id)"
      class="ag-theme-devinco"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)"
      (gridReady)="onGridReady($event)"
      (toolPanelVisibleChanged)="toolPanelVisibilityChanged($event)">
    </ag-grid-angular>
  </dv-grid>
}
